<div class="container">
  <div class="row pt-4 d-flex align-items-center">
    <div class="col-7 offset-1 step-title">
      <h5 class="mb-0">{{selectedStep?.stepName}}</h5>
    </div>
    <div class="col-md-4 mb-2">
      <lib-step-status-update-component-library class="im-disabled" [visaType]="" [stepDetails]="selectedStep"
        type="EDIT" class="float-right">
      </lib-step-status-update-component-library>
    </div>
  </div>

  <form [formGroup]="stepsForm" class="mb-4">
    <div class="row mb-3 pre-pdf-to-workflow-grid-system" *ngIf="prePDFToWorkflow">
      <div class="gridSystem col-10 offset-1" [formGroup]="addForm" cdkDragBoundary=".example-boundary">
        <div *ngFor="let _data of htmlRenderObj; let i = index;" class="vd-drag-box mainRepeatDragPanel" id={{i}}
          [ngClass]="{'leftAlign': _data.align == 'left'}"
          [style.transform]="'translate3d(' + _data.coordinateX + 'px, '+ _data.coordinateY + 'px, 0px)'">
          <div class="vd-heading-container">
            <div *ngIf="_data.style">
              <div class="labelHeading" [ngStyle]="_data.style.width" *ngIf="_data.layoutCode !== 'VdSwitchGroupComponent' &&
                  _data.layoutCode !== 'VdDividerComponent' &&
                  _data.layoutCode !== 'VdLabelComponent' &&
                  _data.layoutCode !== 'CustomQuestionsGroupComponent' &&
                  _data.layoutCode !== 'VdTextAreaComponent' &&
                  _data.layoutCode !== 'CustomGridEditor' &&
                  _data.layoutCode !== 'CustomTextFieldComponent' &&
                  _data.layoutCode !== 'VdPhoneComponent' &&
                  _data.layoutCode !== 'VdEadLibraryComponent' &&
                  _data.layoutCode !== 'VdAddGenerateFormComponent' &&
                  _data.layoutCode !== 'CustomCalenderComponent' && 
                  _data.layoutCode !== 'CustomDateTimePickerComponent' && 
                  _data.layoutCode !== 'VdCountryStateComponent'">{{_data.label}}</div>
            </div>
            <div class="labelHeading" *ngIf="_data.layoutCode === 'VdPhoneComponent'">{{_data.label}}</div>
          </div>
          <app-component-loader class="inlineblock" [rendercomponent]="_data.layoutCode" [sublabel]="_data.subText"
            [validation]="_data.mandatory" [readonly]="_data.readonly" [minLength]="_data.minLength"
            [maxLength]="_data.maxLength" [placeHolders]="_data.placeholder"
            [groupElementProperty]="_data.groupElementProperty"
            [typeOfButton]="_data.layoutCode ==='StepStatusUpdateComponentLibraryComponent' && _data.label === 'Edit' ? 'EDIT' : 'MARK_COMPLETE'"
            [group]="addForm" [groupName]="_data.layoutCode ==='VdSwitchGroupComponent'  ? 'switchGroup' : _data.name"
            [inputParams]="_data"></app-component-loader>
        </div>
      </div>
    </div>
    <div class="row mb-3 post-pdf-to-workflow-grid-system" *ngIf="prePDFToWorkflow === false">
      <div class="gridSystem col-10 offset-1">
        <div class="row inner-grid-system clearfix">
          <ng-template ngFor let-data [ngForOf]="htmlRenderObj" let-i="index">
            <div *ngIf="!data.emptyCol" class="vd-drag-box mainRepeatDragPanel" id={{i}}
              [ngClass]="{'leftAlign': data.align == 'left', 'col-4': data.numberOfColumn && data.numberOfColumn === 4, 'col-6': data.numberOfColumn && data.numberOfColumn === 6, 'col-8': data.numberOfColumn && data.numberOfColumn === 8, 'col-12': data.numberOfColumn && data.numberOfColumn === 12, 'vd-drag-box-padding': !data.numberOfColumn}"
              [ngStyle]="{'top': data.coordinateY + 'px','left': data.coordinateX+'px' }">
              <div class="vd-heading-container">
                <div *ngIf="data.style">
                  <div class="labelHeading" [ngStyle]="data.style.width" *ngIf="data.layoutCode !== 'VdSwitchGroupComponent' &&
                        data.layoutCode !== 'VdDividerComponent' &&
                        data.layoutCode !== 'VdLabelComponent' &&
                        data.layoutCode !== 'CustomQuestionsGroupComponent' &&
                        data.layoutCode !== 'VdTextAreaComponent' &&
                        data.layoutCode !== 'CustomGridEditor' &&
                        data.layoutCode !== 'CustomTextFieldComponent' &&
                        data.layoutCode !== 'VdPhoneComponent' &&
                        data.layoutCode !== 'VdEadLibraryComponent' &&
                        data.layoutCode !== 'VdAddGenerateFormComponent' &&
                        data.layoutCode !== 'CustomCalenderComponent' && 
                        data.layoutCode !== 'CustomDateTimePickerComponent' && 
                        data.layoutCode !== 'VdCountryStateComponent' && 
                        data.layoutCode !== 'CustomButtonComponent'">{{data.label}}</div>
                  </div>
                  <div class="labelHeading" *ngIf="data.layoutCode === 'VdPhoneComponent'">
                    {{data.label}}
                  </div>
                </div>
                <div class="labelHeading" *ngIf="data.layoutCode === 'VdPhoneComponent'">
                  {{data.label}}
                </div>
              </div>

              <div class="alignmentFixes">
                <app-component-loader class="inlineblock" [rendercomponent]="data.layoutCode" [sublabel]="data.subText"
                  [validation]="data.mandatory" [readonly]="data.readonly" [minLength]="data.minLength"
                  [maxLength]="data.maxLength" [placeHolders]="data.placeholder"
                  [groupElementProperty]="data.groupElementProperty"
                  [typeOfButton]="data.layoutCode ==='StepStatusUpdateComponentLibraryComponent' && data.label === 'Edit' ? 'EDIT' : 'MARK_COMPLETE'"
                  [groupName]="data.layoutCode ==='VdSwitchGroupComponent'  ? 'switchGroup' : data.name"
                  [inputParams]="data" [group]="addForm"></app-component-loader>
              </div>
            <!-- </div> -->
            <div *ngIf="data.emptyCol" class="clearfix"></div>
          </ng-template>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-10 d-flex align-items-center" style="margin: 0px auto;">
        <div class="col-md-2">
          <button pButton type="submit" label="Save" title="Save" class="save-btn im-disabled"
            icon="pi pi-save"></button>
        </div>
        <div class="col-md-2">
          <button pButton type="button" label="Cancel" title="Cancel" icon="pi pi-times-circle" class="p-button-secondary cancel-btn button-width-icon-left
                      d-flex alogn-items-center im-disabled">
          </button>
        </div>
        <div class="col-md-5"></div>
        <div class="col-md-6">
          <lib-step-status-update-component-library class="im-disabled" [stepDetails]="selectedStep"
            [type]="'MARK_COMPLETE'"></lib-step-status-update-component-library>
        </div>
      </div>
    </div>
  </form>
</div>
